/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { TApproveTimeEntryRequest } from '../models/TApproveTimeEntryRequest';
import type { TGetTimeEntryResponse } from '../models/TGetTimeEntryResponse';
import type { TListTimeEntriesResponse } from '../models/TListTimeEntriesResponse';
import type { TLogManualTimeRequest } from '../models/TLogManualTimeRequest';
import type { TTalentManagerEngagementId } from '../models/TTalentManagerEngagementId';
import type { TTalentManagerTimeEntryId } from '../models/TTalentManagerTimeEntryId';
import type { TUpdateTimeEntryRequest } from '../models/TUpdateTimeEntryRequest';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class TalentManagerTimeService {
    /**
     * List time entries for an engagement
     * @param engagementId
     * @returns TListTimeEntriesResponse Ok
     * @throws ApiError
     */
    public static listTimeEntries(
        engagementId: TTalentManagerEngagementId,
    ): CancelablePromise<TListTimeEntriesResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/talent-manager-time',
            query: {
                'engagementId': engagementId,
            },
        });
    }
    /**
     * Log manual time for an engagement
     * @param requestBody
     * @returns TGetTimeEntryResponse Ok
     * @throws ApiError
     */
    public static logManualTime(
        requestBody: TLogManualTimeRequest,
    ): CancelablePromise<TGetTimeEntryResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/talent-manager-time/manual',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * Update a time entry
     * @param id
     * @param requestBody
     * @returns TGetTimeEntryResponse Ok
     * @throws ApiError
     */
    public static updateTimeEntry(
        id: TTalentManagerTimeEntryId,
        requestBody: TUpdateTimeEntryRequest,
    ): CancelablePromise<TGetTimeEntryResponse> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/talent-manager-time/{id}',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * Approve or unapprove a pending time entry for billing
     * @param id
     * @param requestBody
     * @returns TGetTimeEntryResponse Ok
     * @throws ApiError
     */
    public static approveTimeEntry(
        id: TTalentManagerTimeEntryId,
        requestBody: TApproveTimeEntryRequest,
    ): CancelablePromise<TGetTimeEntryResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/talent-manager-time/{id}/approve',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
}
